import React from 'react';
import { Route, IndexRoute, Router } from 'react-router';
import Dashboard from './views/dashboard/Dashboard';
import HomeLayout from './views/layouts/HomeLayout/HomeLayout';
import App from './App';
import MyAccount from './views/myaccount/MyAccount';
import Checkout from './views/checkout/Checkout';
import NotFound from './views/common/NotFound';
import CustomerOrderHistory from './views/CustomerOrderHistory';
import ResetPassword from './views/auth/passwordreset/ResetPassword';
import ResetPasswordLayout from './views/layouts/ResetPasswordLayout';
import CheckoutLayout from './views/layouts/CheckoutLayout';
import {
  MY_ACCOUNT,
  ORDER_HISTORY,
  CHECKOUT,
  PASSWORD,
  RESET_PASSWORD,
} from './util/avialableRoutes';

export default (
  <Router>
    <Route path={`/:rname/${PASSWORD}`} component={ResetPasswordLayout}>
      <Route
        path={`/:rname/${RESET_PASSWORD}`}
        exact
        component={ResetPassword}
      />
    </Route>
    <Route component={App}>
      <Route path="/:rname" component={HomeLayout}>
        <IndexRoute component={Dashboard} />
        <Route
          path={`/:rname/${MY_ACCOUNT}${'(/:mode)(/:addFunds)'}`}
          component={MyAccount}
        />
        <Route path={`/:rname/${ORDER_HISTORY}`} component={CustomerOrderHistory} />
        <Route component={CheckoutLayout}>
          <Route path={`/:rname/${CHECKOUT}`} component={Checkout} />
        </Route>
      </Route>
    </Route>
    <Route path="*" component={NotFound} />
  </Router>
);



// WEBPACK FOOTER //
// ./src/routes.js